import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicFrequency({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 1.25c2.13 0 4.1 1 5.36 2.65l-.08-.1.1-.76a.75.75 0 01.75-.64h.1c.4.06.7.44.64.85l-.35 2.48a.75.75 0 01-.85.64l-2.47-.35a.75.75 0 01.2-1.49l.62.09A5.24 5.24 0 002.75 8a5.25 5.25 0 0010.5 0 .75.75 0 111.5 0A6.75 6.75 0 118 1.25zM7.75 4.7c.28 0 .5.22.5.5v2.55h2.55c.28 0 .5.22.5.5v.5a.5.5 0 01-.5.5H7.25a.5.5 0 01-.5-.5V5.2c0-.28.22-.5.5-.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicFrequency.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicFrequency.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicFrequency svgRef={ref} {...props} />);
export default ForwardRef;
